import type { Theme } from '@mui/material';

export const getColorConfig = (theme: Theme) => {
  const colorConfig = [
    {
      bgColor: theme.palette.primary.cowbellBlue,
      textColor: theme.palette.common.white,
    },
    {
      bgColor: theme.palette.text.text3,
      textColor: theme.palette.common.white,
    },
    {
      bgColor: theme.palette.common.turquoise,
      textColor: theme.palette.common.white,
    },
    {
      bgColor: theme.palette.common.petrol,
      textColor: theme.palette.common.white,
    },
    {
      bgColor: theme.palette.common.darkBlue2,
      textColor: theme.palette.common.white,
    },
  ];

  return colorConfig;
};
